import { createAction } from 'redux-act'

const fetchRewardDetailStart = createAction('REWARDS/fetch detail start')
const fetchRewardDetailSuccess = createAction<any>('REWARDS/fetch detail success')
const fetchRewardDetailFail = createAction('REWARDS/fetch detail fail')

const fetchRewardsStart = createAction('REWARDS/fetch start')
const fetchRewardsSuccess = createAction('REWARDS/fetch success')
const fetchRewardsFail = createAction('REWARDS/fetch fail')

const setIsShowAll = createAction('REWARDS/set show all rewards')

const redeemOfferStart = createAction('REWARDS/redeem in store start')
const redeemOfferSuccess = createAction('REWARDS/redeem in store success')
const redeemOfferFail = createAction('REWARDS/redeem in store fail')

const cancelActiveOffer = createAction('REWARDS/cancel active offer')

const addOfferToBagStart = createAction('REWARDS/add offer to bag start')
const addOfferToBagSuccess = createAction('REWARDS/offer added to bag')
const addOfferToBagFail = createAction('REWARDS/failed to add offer to bag')

const fetchPromotionCodeStart = createAction(
  'REWARDS/fetch external collabration promotion code start',
)
const fetchPromotionCodeSuccess = createAction<string>(
  'REWARDS/fetch external collabration promotion code',
)
const fetchPromotionCodeFail = createAction<any>(
  'REWARDS/Fail to fetch external collabration promotion code',
)
const resetPromotionCodeState = createAction('Reset promotion code loading state')

const setSelectedTab = createAction<string>('REWARDS/set selected tab')

export default {
  fetchRewardDetailStart,
  fetchRewardDetailSuccess,
  fetchRewardDetailFail,
  fetchRewardsStart,
  fetchRewardsSuccess,
  fetchRewardsFail,
  setIsShowAll,
  redeemOfferStart,
  redeemOfferSuccess,
  redeemOfferFail,
  cancelActiveOffer,
  addOfferToBagStart,
  addOfferToBagSuccess,
  addOfferToBagFail,
  fetchPromotionCodeStart,
  fetchPromotionCodeSuccess,
  fetchPromotionCodeFail,
  resetPromotionCodeState,
  setSelectedTab,
}
